import { createThunkRequest, GET, POST } from '@webapp/account/src/libs/request';
import { profileSlice } from '@webapp/account/src/resources/profile/slice';

import { mapUser } from './map';

export const extraUsersList = createThunkRequest(
    'users/extraList',
    async () => {
        const { mainUser, rows, byDate } = await POST('list/subuser');

        return {
            users: [mainUser, ...rows].map(mapUser),
            usersByDate: [mainUser, ...byDate].map(mapUser),
        };
    },
    { notify: false },
);

export const extraUserAdd = createThunkRequest(
    'users/addExtra',
    async (
        {
            email,
            name,
        }: {
            email: string;
            name: string;
        },
        { dispatch },
    ) => {
        await POST('reg/subuser', {
            user: email,
            name,
        });

        dispatch(profileSlice.actions.incUserLicence());
        await dispatch(extraUsersList({}));

        return {
            message: 'Пользователь успешно создан. На указанный e-mail выслано письмо с активацией аккаунта',
        };
    },
);

export const prolongExtraUser = createThunkRequest(
    'users/prolongExtra',
    async ({ userId }: { userId: number }, { dispatch }) => {
        const resp = await POST('add/subuser_time', {
            id: userId,
        });
        dispatch(profileSlice.actions.incUserLicence());
        await dispatch(extraUsersList({}));

        return resp;
    },
);

export const postPermissions = createThunkRequest(
    'users/postPermissions',
    async (data: { users: Array<number>; folderId: number; userId: number; folders: Array<number> }) => {
        return await POST('add/user_permissions', data);
    },
);

export const getPermissions = createThunkRequest(
    'users/getPermissions',
    (data: { users: Array<number>; folderId: number; byUsers: boolean }) => {
        return POST('show/user_permissions', data);
    },
    { notify: false },
);

export const changeUserRole = createThunkRequest(
    'users/changeUserRole',
    async (data: { userId: number; role: number }) => {
        return await POST('change/user_role', data);
    },
);

export const changeUserName = createThunkRequest(
    'users/changeUserName',
    async (data: { userId: number; name: string }) => {
        return await POST('change/user_name', data);
    },
);

export const getSuperAdminUsers = createThunkRequest(
    'users/getSuperAdminUsers',
    () => {
        return GET('get/superadmin_users');
    },
    { notify: false },
);

export const deleteSubuser = createThunkRequest(
    'users/deleteSubuser',
    async (data: { subuser: number; transferTo: number }) => {
        return await POST('delete/subuser', data);
    },
    {
        notify: 'Пользователь удален',
    },
);
